document.addEventListener('DOMContentLoaded', () => {
  const ordinal = (day) => {
    if (day % 100 >= 11 && day % 100 <= 13) return `${day}th`;
    const suffix = ['th', 'st', 'nd', 'rd'][day % 10] || 'th';
    return `${day}${suffix}`;
  };

  const calculateDeliveryDate = () => {
    const now = new Date();
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istNow = new Date(utcTime + istOffset);

    const minDays = 3;
    const maxDays = 4;

    const minDate = new Date(istNow);
    minDate.setDate(minDate.getDate() + minDays);

    const maxDate = new Date(istNow);
    maxDate.setDate(maxDate.getDate() + maxDays);

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const minMonth = months[minDate.getMonth()];
    const maxMonth = months[maxDate.getMonth()];

    const minLabel = minMonth === maxMonth ? ordinal(minDate.getDate()) : `${ordinal(minDate.getDate())} ${minMonth}`;
    const maxLabel = `${ordinal(maxDate.getDate())} ${maxMonth}`;

    return `Delivery between ${minLabel} and ${maxLabel}`;
  };

  const deliveryText = calculateDeliveryDate();

  const deliveryDateClaims = document.querySelectorAll('[data-expected-delivery-date="true"]');
  deliveryDateClaims.forEach((claim) => {
    claim.textContent = deliveryText;
  });

  const purchaseBenefitsDelivery = document.querySelector('[data-purchase-benefits-delivery]');
  const purchaseBenefitsDeliveryRow = document.querySelector('[data-purchase-benefits-delivery-row]');
  if (purchaseBenefitsDelivery) {
    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      const isOutOfStock = (variant.inventory_quantity || 0) <= 0;
      const continueSellingOff = variant.inventory_policy === 'deny';
      const continueSellingOn = variant.inventory_policy === 'continue';

      if (isOutOfStock && continueSellingOff) {
        purchaseBenefitsDeliveryRow?.classList.add('hidden');
        purchaseBenefitsDelivery.removeAttribute('data-expected-delivery-date');
        purchaseBenefitsDelivery.setAttribute('data-display-mode', 'hidden');
        purchaseBenefitsDelivery.textContent = '';
        return;
      }

      purchaseBenefitsDeliveryRow?.classList.remove('hidden');

      if (isOutOfStock && continueSellingOn) {
        purchaseBenefitsDelivery.removeAttribute('data-expected-delivery-date');
        purchaseBenefitsDelivery.setAttribute('data-display-mode', 'variant-offer');
        purchaseBenefitsDelivery.textContent = variant.variant_offer || '';
        return;
      }

      purchaseBenefitsDelivery.setAttribute('data-expected-delivery-date', 'true');
      purchaseBenefitsDelivery.setAttribute('data-display-mode', 'delivery-date');
      purchaseBenefitsDelivery.textContent = deliveryText;
    });
  }
});
